import { nanoid } from 'nanoid'
import { AccessTokenType } from './tokens'
import { injectBearer } from './bearer'
import {
  ACCESS_TOKEN,
  ID_TOKEN,
  NONCE,
  PRAXIS_REDIRECT_AFTERAUTH,
} from '../constants'

/*
    ____________________________________________________
   | STORAGE                                            |
   |____________________________________________________|
   | Helper methods to manage resources in localStorage |
   |____________________________________________________|
*/

export const storageSet = (k: string, v: string): void => {
  try {
    window.localStorage.setItem(k, v)
  } catch (e) {
    console.error(e)
  }
}

export const storageGet = (k: string): string | null => {
  return window.localStorage.getItem(k)
}

export const storageClear = (k: string): void => {
  window.localStorage.removeItem(k)
}

export const setKeys = (
  accessToken: string,
  accessTokenKey: string = ACCESS_TOKEN,
  accessTokenType: AccessTokenType = '',
  idToken: string,
): void => {
  storageSet(
    accessTokenKey,
    accessTokenType === 'Bearer' ? injectBearer(accessToken) : accessToken,
  )
  storageSet(ID_TOKEN, idToken)
}

export const getRedirect = (): string | null => {
  const redirect = storageGet(PRAXIS_REDIRECT_AFTERAUTH)
  if (redirect) {
    storageClear(PRAXIS_REDIRECT_AFTERAUTH)

    // Don't return a redirect URL if that URL is already loaded
    return redirect !== window.location.href ? redirect : null
  }
  return null
}

export const getNonce = (): string => {
  let nonceCheck = storageGet(NONCE)
  if (nonceCheck) {
    return nonceCheck
  } else {
    // no nonce set, so generate a random one
    const nonce = nanoid()
    storageSet(NONCE, nonce)
    return nonce
  }
}

export const clearAllStorage = (
  accessTokenKey: string = ACCESS_TOKEN,
): void => {
  storageClear(accessTokenKey)
  storageClear(ID_TOKEN)
  storageClear(PRAXIS_REDIRECT_AFTERAUTH)
  storageClear(NONCE)
}
